export function rangeSlider() {
    $(".range-slider").ionRangeSlider({
        type: "double",
        // grid: true,
        min: range.min,
        max: range.max,
        from: range.from,
        to: range.to,
        prefix: range.prefix
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/range-slider.js